<template>
  <div class="content-edit_box">
    <div class="recive_person">
      <div class="header">
        <div class="text">接收对象：</div>
          <el-button text type="primary" @click="showDialog">
            <el-icon><UserFilled /></el-icon>选择学员服务群
          </el-button>
      </div>
      <TagBox :sendTargets="sendTargets" @close="handleClose"></TagBox>
    </div>
    <div class="send_content">
      <div class="header">
        <div class="text">发送内容：</div>
        <el-button @click='addTextCard'  :disabled="!canAddNewContent"><el-icon class="marginRight5"><ChatLineRound/></el-icon>添加文本</el-button>
        <el-button @click='addFileCard' :disabled="!canAddNewContent"><el-icon class="marginRight5"><Document /></el-icon>添加通用文件<el-tooltip class="box-item" effect="dark" content="每个学员都将接收到添加的通用文件"
            placement="top">
            <el-icon>
              <InfoFilled color="#67C23A" />
            </el-icon>
          </el-tooltip></el-button>
        <el-button @click='addFolderCard' :disabled="!canAddNewContent"><el-icon class="marginRight5"><FolderOpened /></el-icon>添加定制文件<el-tooltip class="box-item" effect="dark" content="学员将接收到与之匹配的定制文件"
            placement="top">
            <el-icon>
              <InfoFilled color="#67C23A" />
            </el-icon>
          </el-tooltip></el-button>
      </div>
      <EditSendContent v-model="taskContents.sendContent" :sendTarget="sendTargets"></EditSendContent>
    </div>
    <ChooseWxGroup v-model="showChooseWxGroup" :choosedList="sendTargets" @confirm="getTargets" @cancel="showChooseWxGroup=false"></ChooseWxGroup>
  </div>
</template>

<script setup>
import { ref,computed } from 'vue'
import EditSendContent from './editSendContent.vue';
import ChooseWxGroup from '@/components/chooseWxGroup.vue';
import { getUid } from '@/utils/util.js'
import TagBox from '@/components/tagListBox.vue'
const props = defineProps({
  taskContents:{
    type: Object,
    required:true
  }
})
const showChooseWxGroup = ref(false);
const canAddNewContent = computed(()=>{
  return props.taskContents.sendContent.length < 20;
})
const sendTargets = computed(()=>props.taskContents.sendTarget)

const showDialog = ()=>{
  showChooseWxGroup.value = true
}
const getTargets = ({addStudents,deleteStudents})=>{
  showChooseWxGroup.value = false
  props.taskContents.sendTarget = props.taskContents.sendTarget.concat(addStudents).filter(item=>{
    return !deleteStudents.some(delItem=>delItem.studentCode == item.studentCode)
  })
}
const addTextCard = () => {
  props.taskContents.sendContent.unshift({
    msgType: 'text',
    showContent: ``,
    sendContent: "",
    id: getUid(),// 后端返回ID
  },)
}
const addFileCard = () => {
  props.taskContents.sendContent.unshift({
    msgType: 'file',
    filePaths:[],
    fakeId:getUid(),
  })
}
const addFolderCard = () => {
  props.taskContents.sendContent.unshift({
    msgType: 'folder',
    showContent: [],// 文件类型的展示数据和发送数据应该是一致的
    sendContent: [],
    // sendContent: [{
    //   studentName: '',
    //   studentCode: '',
    //   filePaths: []
    // }],
  })
}
const handleClose = (tag) => {
  // console.log('remvoe',tag,props.taskContents.sendTarget)
  props.taskContents.sendTarget = props.taskContents.sendTarget.filter(item=>item.studentCode != tag.studentCode)
}

</script>

<style lang="less" scoped>
.content-edit_box {
  .header {
    display: flex;
    align-items: center;
  }
  .marginRight10 {
    margin-right: 10px;
  }
  .marginRight5 {
    margin-right: 5px;
  }
}
</style>